import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminWebSeriesNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('web-series');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
